import * as React from 'react'
import { BulkActionButton } from '../BulkActionButton'

type Props = { hasPermission: boolean }
export const BulkUpdateExpectedClosingDateButton: React.FC<Props> = (props) => (
  <BulkActionButton
    type="updateExpectedClosingDate"
    helperText="Mass update the expected closing date for selected records."
    hasPermission={props.hasPermission}
    errorString="You do not have permission to perform bulk updates."
  >
    Expected Closing Date
  </BulkActionButton>
)
BulkUpdateExpectedClosingDateButton.displayName =
  'BulkUpdateExpectedClosingDateButton'
